import http from 'plugins/axios';

export default {

  updateVolunteer({ id, status }) {
    return http.post({
      url: `/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status
      },
      dataType: 'form'
    });
  },


  //获取盒子列表
  getBoxList(data) {
    return http.get({
      url: `/admin/activity/box/list`,
      data: data
    });
  },


  ////添加盒子
  createBox(data) {
    return http.post({
      url: `/admin/activity/box/create`,
      data: data
    });
  },
  ////修改盒子信息
  updateBox(data) {
    return http.post({
      url: `/admin/activity/box/update`,
      data: data
    });
  },

  ////删除盒子
  deleteBox(data) {
    return http.post({
      url: `/admin/activity/box/delete`,
      data: {
        id:data
      },
      dataType:'form'
    });
  },


};
